// eslint-disable-next-line no-shadow
export enum NavRouteLabel {
	Home = `Home`,
	DevelopmentCaseStudies = `Case Studies`,
	Connect = `Connect`,
	GitHub = `GitHub`,
	Gallery = `Gallery`,
	Philosophy = `Philosophy`
}